import { Color } from '@/components/portfolio/components/sharedTypes'
import { clientHomeData, clientPageData, PortfolioComponent } from '../../type/client-index'
import {
  Leslie1,
  Leslie2,
  Leslie3,
  Leslie4,
  Leslie5,
  Leslie6,
  Leslie7,
  Leslie8,
  Leslie9,
  Leslie10,
  Leslie11,
  Leslie12,
  Leslie13,
  Leslie14,
  LesliePresentation,
  Video1,
  Video2,
  Video3,
  LeslieFleures
} from './assets'

export const home: clientHomeData = {
  slug: 'leslie-en-cuisine',
  name: 'Leslie en cuisine',
  types: ['Création de contenu'],
  image: Leslie8
}

const detailed: clientPageData = {
  seo: {
    // Le titre est généré comme ça: {name} - Atelier Milky
    title: 'Leslie en cuisine',
    description: 'Découvrez notre travail avec Leslie en cuisine.'
  },
  blocks: [
    {
      id: 0,
      componentName: PortfolioComponent.presentationSlide,
      props: {
        title: home.name,
        titleColor: Color.blue,
        types: home.types,
        images: [LesliePresentation],
        urls: { website: 'https://www.leslieencuisine.com/', instagram: 'https://www.instagram.com/leslieencuisine/' },
        subtitle: 'La marque',
        description: {
          cols: 1,
          content: [
            "Suivie par plus de 25k d'abonnés, Leslie en Cuisine est une cheffe cuisinière renommée ! Après un parcours dans l'émission Objectif Top Chef, elle a décidé de lancer sa boîte de production tout en proposant en parallèle ses conseils culinaires sur les réseaux sociaux. Des recettes faciles et surtout gourmandes, voilà ce que Leslie propose sur ses différentes plateformes."
          ]
        }
      }
    },
    {
      id: 1,
      componentName: PortfolioComponent.singleImage,
      props: {
        fullHeight: false,
        image: LeslieFleures,
        variant: 1,
        pr: true
      }
    },
    {
      id: 2,
      componentName: PortfolioComponent.imageGrid,
      props: {
        title: 'Notre travail',
        cols: 1,
        rightPadding: true,
        spaceBetween: true,
        description: {
          cols: 1,
          content: [
            "La création de contenu est au cœur de la collaboration entre Atelier Milky et Leslie en Cuisine. Chaque mois, un shooting photo ainsi que la réalisation de plusieurs reels sont prévus ! Pour chaque reels, Leslie se voit remettre une photo de couverture ainsi qu'une stratégie pour une visibilité maximum."
          ]
        },
        images: [Leslie1, Leslie2, Leslie3, Leslie4]
      }
    },
    {
      id: 3,
      componentName: PortfolioComponent.imageGrid,
      props: {
        cols: 1,
        rightPadding: true,
        alignTop: true,
        variant: 2,
        images: [Leslie5, Leslie6]
      }
    },
    {
      id: 4,
      componentName: PortfolioComponent.imageGrid,
      props: {
        cols: 1,
        rightPadding: true,
        images: [Leslie7, Leslie8, Leslie9, Leslie10]
      }
    },
    {
      id: 5,
      componentName: PortfolioComponent.imageGrid,
      props: {
        cols: 1,
        spaceBetween: true,
        rightPadding: true,
        images: [Leslie11, Leslie12, Leslie13, Leslie14]
      }
    },
    // {
    //   id: 6,
    //   componentName: PortfolioComponent.imageGrid,
    //   props: {
    //     cols: 1,
    //     alignTop: true,
    //     images: [Leslie14]
    //   }
    // },
    {
      id: 7,
      componentName: PortfolioComponent.fullHeightVideos,
      props: {
        pl: true,
        pr: true,
        variant: 3,
        videosCfIds: [Video3, Video2, Video1]
      }
    }
  ]
}

export default detailed
